<template>
  <label :for="labelFor" class="inline-block text-80 leading-tight">
    <slot></slot>
  </label>
</template>

<script>
  export default {
    props: {
      labelFor: {
        type: String,
        default: null,
      },
    },
  };
</script>
